import {Component, OnInit} from '@angular/core';
import {Guard} from '../../../core/services/guard.service';

@Component({
    selector: 'itpx-dashboard',
    templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

    private tiles : Array<any> = [];
    constructor(private guard: Guard) {}

    ngOnInit(): void {
        this.initiateTiles();
    }

    initiateTiles() {
        this.tiles.length = 0;
        this.tiles.push({
            title: 'Product Data',
            redirectPath: 'product-data',
            description: 'Manage Product Data',
            icon: 'fa-archive',
            permission: 'agora.product-data'
        });
        this.tiles.push({
            title: 'Pricing Data',
            redirectPath: 'pricing-data',
            description: 'Manage Price Lists',
            icon: 'fa-usd-circle',
            permission: 'agora.pricing-data',
        });
        this.tiles.push({
            title: 'Account Data',
            redirectPath: 'account-data',
            description: 'Manage Account Data',
            icon: 'fa-folder',
            permission: 'agora.account-data'
        });
        this.tiles.push({
            title: 'Configurations',
            redirectPath: 'configurations',
            description: 'Manage Configurations',
            icon: 'fa-cogs',
            permission: 'agora.configurations'
        });
        this.tiles.push({
            title: 'Account Configurations',
            redirectPath: 'account-configurations',
            description: 'Manage Account Configurations',
            icon: 'fa-wrench',
            permission: 'agora.configurations'
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/dashboard/dashboard.component.ts